// extracted by mini-css-extract-plugin
export var dropdownButton = "_3c-0";
export var fullWidthDropdownButton = "_3c-1";
export var icon = "_3c-3";
export var iconPlaceholder = "_3c-2";
export var menuItemRow = "_3c-9";
export var separator = "_3c-e";
export var shortcutContainer = "_3c-7";
export var shortcutContainerFilled = "_3c-8";
export var shortcutIconLg = "_3c-6";
export var shortcutIconMd = "_3c-5";
export var shortcutIconSm = "_3c-4";
export var submenuChevron = "_3c-d";
export var submenuDropdown = "_3c-a";
export var submenuTriggerRow = "_3c-b";
export var submenuTriggerRowOpen = "_3c-c";